// frontend/src/modules/email/pages/TestSendTab.tsx
import * as React from 'react';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { VISUAL } from '../../../design-system/visual';
import { emailApi } from '../api';

export function TestSendTab() {
  const [to, setTo] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [last, setLast] = React.useState<{ log_id: string; provider_message_id: string } | null>(null);

  async function send() {
    if (!to.trim()) { toast.error('Enter a recipient'); return; }
    setBusy(true);
    try {
      const r = await emailApi.testSend(to.trim());
      setLast({ log_id: r.log_id, provider_message_id: r.provider_message_id });
      toast.success('Test email dispatched');
    } catch (err: any) {
      toast.error('Send failed', { description: err.message });
    } finally { setBusy(false); }
  }

  return (
    <section className={[VISUAL.bento, 'p-6 sm:p-7 max-w-xl space-y-5'].join(' ')}>
      <div>
        <h3 className={VISUAL.dashSection}>Send a test</h3>
        <p className="text-[13px] text-muted-foreground mt-1.5 leading-relaxed">
          Dispatches a synthetic <code className="font-mono text-[11.5px]">owner_invoice_sent</code> template using your currently
          configured provider — useful for verifying SMTP credentials or the Platform Fallback wiring.
        </p>
      </div>
      <div className="grid gap-1.5">
        <Label>Recipient</Label>
        <Input type="email" value={to} onChange={(e) => setTo(e.target.value)} placeholder="you@example.com" />
      </div>
      <div className="flex justify-end">
        <Button type="button" disabled={busy} onClick={send} className="rounded-full h-10 px-5 text-[13px] font-semibold gap-1.5">
          <Send className="h-3.5 w-3.5" />
          {busy ? 'Sending…' : 'Send test'}
        </Button>
      </div>
      {last && (
        <div className="border-t border-border/40 pt-4 text-[12px] text-muted-foreground grid gap-1.5">
          <div>Log id: <code className="font-mono text-[11.5px] text-foreground/85">{last.log_id}</code></div>
          <div>Provider message id: <code className="font-mono text-[11.5px] text-foreground/85">{last.provider_message_id}</code></div>
        </div>
      )}
    </section>
  );
}
